import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactJWPlayer from 'react-jw-player';
import { getCookie } from 'shared/utils/cookie';
import { startLoading, finishLoading } from 'shared/actions/loading.action';
import uuid from 'uuid';

import {
  getAnnonMediaKeyRequest,
  getMediaKeyRequest,
} from 'shared/actions/mediaInfo.action';

import classNames from 'classnames/bind';
import styles from './Video.scss';

const {
  REACT_APP_JW_PLAYER_LICENSE_KEY,
  REACT_APP_JW_PLAYER_SCRIPT,
} = process.env;

const cx = classNames.bind(styles);

@connect(
  (state, props) => {
    return {
      loading: state.shared.loading,
    };
  },
  {
    getAnnonMediaKeyRequest,
    getMediaKeyRequest,
    startLoading,
    finishLoading,
  },
)
class Video extends Component {
  player = null;

  state = {
    playerId: this.props.id || uuid(),
    stage: '',

    controller: {
      playing: false,
      disabled: true,
      currentTime: 0,
      duration: 0,
      percent: 0,
      completed: false,
      // mute: true,
    },
    fullscreen: false,

    index: 0,
    playlist: [],
  };

  _getPlaylist = (media, image) => {
    const playlist = Array.isArray(media)
      ? media
      : [{ file: media, image, withCredentials: true }];
    return playlist;
  };

  _handleMediaKey = async (item = {}, callback) => {
    const { mediaUrl = {} } = item;

    // console.log('_handleMediaKey', { mediaUrl: mediaUrl.file });
    if (mediaUrl && mediaUrl.file && mediaUrl.file.match('cdn.')) {
      // console.log('wowo');
      // console.log({ mediaUrl });

      const access_token = getCookie('dr_access_token');
      if (access_token) {
        await this.props.getMediaKeyRequest(
          {
            type: '',
            step: '',
            mediaUrl: mediaUrl.file,
          },
          callback,
        );
      } else {
        await this.props.getAnnonMediaKeyRequest(
          {
            type: '',
            step: '',
            mediaUrl: mediaUrl.file,
          },
          callback,
        );
      }
    }
    return;
  };

  _handlePlaylist = props => {
    let playlist = [];
    if (props.media) {
      playlist = this._getPlaylist(props.media, props.image);
    }

    if (this.props.media && playlist) {
      this.setState({ playlist });

      // this._handleMediaKey({ mediaUrl: playlist[0] }, () => {
      //   const playlist = this._getPlaylist(props.media, props.image);
      //   this.setState({ playlist });
      // });
    }
  };

  async componentDidMount() {
    // console.log({ media: this.props.media });

    this._handlePlaylist(this.props);
    if (this.props.io !== false) {
      Array.from(document.querySelectorAll('.video-box')).forEach(async box => {
        io.observe(box);
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.media !== this.props.media) {
      const playlist = this._getPlaylist(this.props.media, this.props.image);
      this.setState({
        playlist,
      });
    }

    // if (this.props.loading.status !== prevProps.loading.status) {
    //   this.props.finishLoading();
    // }

    if (this.props.fullscreen !== prevProps.fullscreen) {
    }
  }

  onReady = e => {
    // console.log('onReady', e);
    if (this.player) {
      this.player.stop();
      this.setState({
        controller: {
          ...this.state.controller,
          playing: false,
        },
      });
    }

    this.player = window.jwplayer(this.state.playerId);

    this.player.setControls(true);
    this.player.setConfig({
      autostart: false,
      // mute: true,
      repeat: true,
      volume: 20,
      preload: 'none',
    });

    // this.player.on(
    //   'fullscreen',
    //   this.onExitFullScreen(),
    //   console.log('onReady on'),
    // );
  };

  onPlay = e => {
    // console.log(`onPlay`);
    const { fullscreen = false } = this.props;
    let playlist = [];
    if (this.props.media) {
      playlist = this._getPlaylist(this.props.media, this.props.image);
    }

    this._handleMediaKey({ mediaUrl: playlist[0] }, () => {
      const playlist = this._getPlaylist(this.props.media, this.props.image);
      this.setState({ playlist });
    });

    if (fullscreen) {
      this.player.setFullscreen(fullscreen);
      this.setState({
        fullscreen: true,
      });
    }
    this.setState({
      controller: {
        ...this.state.controller,
        playing: true,
      },
    });
  };

  onPause = e => {
    const { fullscreen } = this.props;
    this.setState({
      controller: {
        ...this.state.controller,
        playing: false,
      },
    });
    console.log('onPuase!!', this.state.controller.playing);

    if (fullscreen) {
      this.setState({
        fullscreen: false,
      });
    }
  };

  onResume = e => {
    const { fullscreen = false } = this.props;
    if (fullscreen) this.player.setFullscreen(fullscreen);
    this.setState({
      controller: {
        ...this.state.controller,
        playing: true,
        completed: false,
      },
      fullscreen: true,
    });
  };

  onExitFullScreen = e => {
    const { fullscreen } = this.props;
    if (fullscreen) this.player.pause();
  };

  render() {
    const {
      radius = false,
      coverSize = '',
      setting,
      type = '',
      media,
      step,
      history,
      loading,
    } = this.props;
    const options = {
      playerScript: REACT_APP_JW_PLAYER_SCRIPT,
      licenseKey: REACT_APP_JW_PLAYER_LICENSE_KEY,
      playerId: this.state.playerId,
      playlist: this.state.playlist,
      width: '100%',
      height: '100%',
      // mute: true,
      onReady: this.onReady,
      onPlay: this.onPlay,
      onPause: this.onPause,
      onResume: this.onResume,
      onTime: this.onTime,
      onExitFullScreen: this.onExitFullScreen,
      onOneHundredPercent: this.onOneHundredPercent,
      useMultiplePlayerScripts: false,
    };

    const display = this.state.playlist.length ? (
      <ReactJWPlayer className="jw-wrapper" {...options} />
    ) : null;

    return (
      <div
        className={cx(
          'Video',
          'video-box',
          radius ? 'radius' : '',
          type === 'hard' && 'hide',
        )}
        id={this.state.playerId}
      >
        {display}
        <Cover
          className={coverSize}
          loading={loading}
          setting={setting}
          playing={this.state.controller.playing}
          onClick={() => {
            console.log('loading!!');
            // if (media && step) {
            //   this.props.getMediaKeyRequest({
            //     type: '',
            //     step: step,
            //     mediaUrl: media,
            //   });
            // }
            const player = window.jwplayer(this.state.playerId);
            // console.log({ player });
            if (player) {
              // console.log({ play: player.play });

              if (this.state.controller.playing) {
                if (player.pause) player.pause();
              } else {
                if (player.play) player.play();
              }
            }
          }}
        />
      </div>
    );
  }
}

export default Video;

const io = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach(entry => {
      const { target } = entry;
      let player = null;

      if (window.jwplayer) {
        player = window.jwplayer(target.id);
      }

      if (player) {
        if (entry.isIntersecting) {
          if (player.play) player.play();
        } else {
          if (player.stop) player.stop();
        }
      }
    });
  },
  {
    root: null,
    threshold: 0.3,
  },
);

const Cover = React.memo(
  ({ playing = false, className = '', onClick, setting = {} }) => {
    let styles = { ...setting };
    return (
      <div
        className={`cover playing-${playing} ${className}`}
        onClick={onClick}
        style={styles}
      />
    );
  },
);
